import { useCallback, useState } from "react";
import { Helmet } from "react-helmet";
import { Outlet } from "react-router";
import { useSearchParams } from "react-router-dom";

import { SortOrder } from "@covertree/agent-portal-graphql";
import { TableView } from "@covertree/ui/table/TableView";
import { LoadingOverlay } from "@covertree/ui";

import { useGetPolicies } from "./useGetPolicies";
import formatPageTitle from "@utils/formatPageTitle";

export default function Policies() {
  const [sequoiaOnly, setSequoiaOnly] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    loading,
    isAnyActionLoading,
    error,
    policies,
    columns,
    filters,
    sortBy,
    order,
    totalCount,
    rowsPerPage,
    currentPage,
    handleChangePage,
    handleFilterChange,
    handleSortChange,
    handleRowsPerPageChange,
  } = useGetPolicies(sequoiaOnly);

  const onSequoiaOnlyButtonClick = useCallback(() => {
    setSequoiaOnly((prev) => {
      searchParams.delete("from");
      setSearchParams(searchParams);
      return !prev;
    });
  }, [searchParams, setSearchParams]);

  return (
    <>
      <Helmet>
        <title>{formatPageTitle("Policies")}</title>
      </Helmet>
      <TableView
        header="Policies"
        loading={loading}
        error={error}
        tabs={filters}
        totalCount={totalCount}
        page={currentPage}
        rows={policies}
        rowsPerPage={rowsPerPage}
        sortBy={sortBy}
        sortOrder={order === SortOrder.Ascending ? "asc" : "desc"}
        columns={columns}
        onTabChange={handleFilterChange}
        onPageChange={handleChangePage}
        onSortChange={handleSortChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        sequoiaFilter={{
          selected: sequoiaOnly,
          onClick: onSequoiaOnlyButtonClick,
        }}
      />
      {isAnyActionLoading && <LoadingOverlay />}
      <Outlet />
    </>
  );
}
